export const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512): Blob => {
  if (!b64Data) {
    return new Blob([], { type: contentType });
  }

  if (b64Data.startsWith('data:')) {
    const commaIndex = b64Data.indexOf(',');
    if (commaIndex !== -1) {
      b64Data = b64Data.slice(commaIndex + 1);
    }
  }

  b64Data = b64Data.trim().replace(/\s+/g, '');
  b64Data = b64Data.replace(/-/g, '+').replace(/_/g, '/');

  const mod = b64Data.length % 4;
  if (mod === 2) {
    b64Data += '==';
  } else if (mod === 3) {
    b64Data += '=';
  } else if (mod === 1) {
    return new Blob([], { type: contentType });
  }

  let byteCharacters: string;
  try {
    byteCharacters = atob(b64Data);
  } catch {
    return new Blob([], { type: contentType });
  }

  const byteArrays: any[] = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });

  return blob;
};
